import React from 'react'
import logoimg from '../../assets/MK1.3.png';
import { useLocation } from 'react-router-dom';
import config from '../../Data/dashboardDara.json';

function PrintCodes() {
  const location = useLocation();
  var {allCodes,title} = location.state;

  const handlePrint = () => {
    window.print(); 
  };

  return (
    <div className=' flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
      <div className='headers  '>
        <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
        <p onClick={handlePrint} className=' print:hidden px-7 py-1 text-white bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70 ml-8'> طباعة </p> 
      </div>

      <div className='all_codes'>
          {allCodes.length && (
            <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
              <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                  <div className='text-base w-[50px] text-center'>الرقم</div>
                  <div className='text-base w-[200px] text-center'>مستر</div>
                  <div className='text-base w-[200px] text-center'>محاضرات</div>
                  <div className='text-base w-[200px] text-center'>كود</div>
                  <div className='text-base w-[100px] text-center'></div>
                </div>
              {allCodes?.map((code,index) => (
                <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] items-center min-w-full w-fit ' key={index}> 
                  <div className='text-base w-[50px] text-center'> {index} </div>
                  <div className='text-base w-[200px] text-center'>{config.name}</div>
                  <div className='text-base w-[200px] text-center'> {title} </div>
                  <div className='text-base w-[200px] text-center'>{code}</div>
                  <div className='text-base w-[100px] text-center'><img src={logoimg} className='w-[100px] rounded-full px-6 '/></div>
                </div>
              ))}
            </div>
          )}
        </div>
      
    </div>
  )
}

export default PrintCodes
